// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__11MkU","title":"Header_title__TVNdJ","side":"Header_side__P59sV"};